import { render } from "./GroupTypeSelector.vue?vue&type=template&id=47e714b0"
import script from "./GroupTypeSelector.vue?vue&type=script&lang=js"
export * from "./GroupTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__